import { createRoute, Navigate } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import MainLayout from 'layouts/dashboard/MainLayout';
import { rootRoute } from 'routes/rootRoute';
import { canAccessGroupPages, WithEnsure } from 'routes/routeUtils';

export const groupParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => WithEnsure(canAccessGroupPages, <MainLayout />),
  path: '/group',
  pendingComponent: LoadingScreen,
});

export const groupIndexRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/',
  component: () => <Navigate to="/group/dashboard" />,
});
